"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTracking = void 0;
const event_tracking_service_1 = require("./services/event-tracking.service");
class EventTracking extends event_tracking_service_1.EventTrackingService {
}
exports.EventTracking = EventTracking;
